<template>
  <div class="app-container">
    <el-form ref="ruleForm" v-loading="loading" :model="form" label-width="120px">
      <el-form-item label="模式选择" class="upload-method">
        <el-select v-model="inputMethod" @change="changeMethod">
          <el-option v-for="m in methods" :key="m.value" :label="m.label" :value="m.value" />
        </el-select>
        <div class="btn">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-form-item>
      <el-form-item label="故事生成方式">
        <el-select v-model="form.type" placeholder="请选择方式">
          <el-option label="问答形式-保险" value="qa" />
          <el-option label="问答形式-通用" value="common" />
          <el-option label="条款形式" value="term" />
          <el-option label="文本形式" value="text" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="inputMethod === 1" label="保险公司">
        <el-select v-model="form.company" filterable placeholder="请选择保险公司">
          <el-option v-for="c in companyList" :key="c.id" :label="c.name" :value="c.name" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="inputMethod === 1" label="PDF样式">
        <el-select v-model="form.pdfStyle">
          <el-option label="竖模式" value="column" />
          <el-option label="横模式" value="row" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="inputMethod === 2" label="知识库的选择" required>
        <el-select v-model="form.file" value-key="id" :clearable="true" placeholder="请选择文件" @clear="clearFile" @change="changeFile">
          <el-option v-for="o in fileOptions" :key="o.id" :label="o.name" :value="o" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="inputMethod === 1" label="文件上传" required>
        <el-upload
          action="#"
          :auto-upload="false"
          class="left"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          accept="file"
        >
          <div>
            <el-button size="small" type="primary">
              点击上传(支持markdown,条款pdf和excel三种格式)
            </el-button>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="知识名称" class="width50" required>
        <el-input v-model="form.name" placeholder="请输入知识名称" />
      </el-form-item>
      <el-form-item label="知识描述" class="width100">
        <el-input v-model="form.desc" placeholder="请输入知识描述" />
      </el-form-item>

      <el-form-item v-if="inputMethod === 0" class="width100 height100 content" label="知识内容" required>
        <el-button @click="addContent">新增</el-button>
        <div v-for="(text,index) in form.content" :key="index" class="center">
          <el-input :id="`textarea${index}`" v-model="form.content[index]" maxlength="3000" show-word-limit type="textarea" placeholder="请输入知识内容" @input="textareaId=`textarea${index}`" />
          <i v-if="index !== 0" class="el-icon-delete" @click="delContent(index)" />
        </div>
      </el-form-item>

      <el-form-item v-if="inputMethod === 1 || inputMethod === 2" class="width100 height100 content" label="知识内容" required>
        <template v-if="form.content[0]">
          <v-md-preview v-for="(text,index) in form.content" :key="index" v-loading="uploadLoading" :text="text" />
        </template>
        <template v-else>
          <el-input v-loading="uploadLoading" readonly maxlength="3000" show-word-limit type="textarea" placeholder="请选择文件进行转换" />
        </template>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import { getCompany, fileSplit, getKnowledge, getKnowledgeDetail, knowledgeSave } from '@/api/knowledgeUpload'
export default {
  data() {
    return {
      inputMethod: 0,
      methods: [
        { label: '手动输入', value: 0 },
        { label: '上传文件', value: 1 },
        { label: '外接知识库', value: 2 }
      ],
      form: {
        name: '',
        desc: '',
        content: [''],
        type: 'term',
        file: { id: '' },
        company: '',
        pdfStyle: 'column'
      },
      fileOptions: [],
      loading: false,
      uploadLoading: false,
      fileList: [],
      isUpload: false,
      textareaId: '',
      companyList: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.textareaId && this.$nextTick(() => {
        var textarea = document.getElementById(this.textareaId)
        if (textarea.value) {
          textarea.style.height = textarea.scrollHeight > 54 ? textarea.scrollHeight + 'px' : 54 + 'px'
        } else {
          textarea.style.height = 54 + 'px'
        }
      })
    })
  },
  created() {
    // 获取保司列表
    this.queryCompany()
    // 获取外接知识库
    this.queryKnowledge()
  },
  methods: {
    delContent(index) {
      this.form.content.splice(index, 1)
    },
    addContent() {
      for (let index = 0; index < this.form.content.length; index++) {
        const el = this.form.content[index]
        if (!el) {
          this.$message({
            message: `请按段落填写知识内容`,
            type: 'error',
            duration: 2 * 1000
          })
          break
        }
        if (index === this.form.content.length - 1) {
          this.form.content.push('')
          break
        }
      }
    },
    changeMethod() {
      this.form = {
        name: '',
        desc: '',
        content: [''],
        type: 'term',
        file: { id: '' },
        company: '',
        pdfStyle: 'column'
      }
    },
    async queryCompany() {
      await getCompany().then(res => {
        this.companyList = res.data
      })
    },
    async queryKnowledge() {
      await getKnowledge().then(res => {
        this.fileOptions = res.data
      })
    },
    onSubmit() {
      console.log('form', this.form)
      let isNext = true
      for (let index = 0; index < this.form.content.length; index++) {
        const el = this.form.content[index]
        if (!el) {
          isNext = false
          this.$message({
            message: `知识内容不能有空段落`,
            type: 'error',
            duration: 2 * 1000
          })
          break
        }
      }
      if (!isNext) {
        return false
      }
      if (!this.form.name) {
        this.$message({
          message: `请填写知识名称`,
          type: 'error',
          duration: 2 * 1000
        })
      } else if (this.form.content.length[0]) {
        this.$message({
          message: `请按段落填写知识内容`,
          type: 'error',
          duration: 2 * 1000
        })
      } else {
        this.loading = true
        const formData = new FormData()
        formData.append('name', this.form.name)
        formData.append('description', this.form.desc)
        this.form.content.forEach(item => {
          formData.append('textBlocks', item)
        })
        formData.append('companyName', this.form.company)
        formData.append('origin', this.inputMethod)
        // formData.append('file', this.fileList[0].raw)
        // formData.append('file', this.fileList.length ? this.fileList[0].raw : {})
        this.fileList.length && formData.append('file', this.fileList[0].raw)
        formData.append('identifyType', this.form.type)
        console.log('file', this.fileList)
        knowledgeSave(formData).then(() => {
          this.$confirm('知识上传成功！您可以在任务资源库使用这个知识生成问答啦～', '上传成功', {
            confirmButtonText: '去生成问答',
            cancelButtonText: '好的',
            type: 'success',
            closeOnClickModal: false,
            showClose: false
          }).then(() => {
            this.$router.push({ name: 'taskBaseList' })
          }).catch(() => {
            this.$router.push({ name: 'knowledgeList' })
          })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 删除文件
    handleRemove() {
      this.fileList = []
      this.form.content = ['']
      this.isUpload = false
    },
    clearFile() {
      this.form.content = ['']
      this.form.name = ''
      this.isUpload = false
    },
    // 上传文件
    handleChange(file, fileList) {
      console.log(55555, file)
      const type = file.name.split('.')
      if (type[type.length - 1] === 'pdf' && !this.form.company) {
        this.form.file = {}
        this.fileList = []
        fileList = this.fileList
        this.$message({
          message: `请先选择保险公司`,
          type: 'error',
          duration: 2 * 1000
        })
        return false
      }
      this.uploadLoading = true
      this.fileList = [file]
      fileList = this.fileList
      console.log(8888, file)
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('type', this.form.type)
      formData.append('companyName', this.form.company)
      formData.append('pdfStyle', this.form.pdfStyle)
      fileSplit(formData).then(res => {
        this.form.content = res.data
        this.form.file = {}
        this.isUpload = true
      }).catch(() => {
        this.fileList = []
        fileList = this.fileList
        this.isUpload = false
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    // 选择文件
    changeFile(file) {
      if (file) {
        this.form.name = file.name
        getKnowledgeDetail({ id: file.id }).then(res => {
          this.form.content = res.data.length ? res.data : ['']
          this.fileList = []
          this.isUpload = true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-form{
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-textarea{
    margin-bottom: 10px;
  }
  .el-form-item__content{
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    .vuepress-markdown-body:not(.custom){
      padding: 0;
    }
  }
  .el-icon-delete{
    color: red;
    padding: 10px;
    font-size: 18px;
  }
  .content{
    .el-form-item__content{
      overflow: auto;
      display: block;
    }
    .el-button{
      margin-bottom: 10px;
      border: 0;
      color: #419eee;
      padding: 10px 5px;
    }
  }
  .el-textarea__inner{
    resize: none;
    word-break: break-all;
    max-height: 300px;
  }
  .el-upload{
    margin-right: 20px;
  }
  .el-select{
    flex-shrink: 0;
    width: 300px;
  }
}
.center{
  display: flex;
  align-items: center;
}
.btn{
  text-align: end;
  position: absolute;
  right: 0;
}
.v-md-editor-preview{
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding: 10px 20px;
  width: 100%;
  margin-bottom: 10px;
  min-height: 54px;
}
.left{
  text-align: left;
  width: 100%;
  display: flex;
}
.center{
  text-align: center;
}
.width30{
  width: 30%;
}
.width50{
  width: 50%;
}
.height100{
  margin-bottom: 0;
  flex:1;
  overflow: hidden;
}
</style>

